<template>
  <div class="icon"
    v-html="getIcon(name)" />
</template>

<script>
import { getIcon } from '@/utils/helpers'
export default {
  props: {
    name: String
  },
  methods: {
    getIcon
  }
}
</script>

<style lang="scss">
  .icon {
    position: relative;
    font-size: 14px;
    line-height: 0;
    display: inline-block;
  }
</style>
